import {
  Box,
  Button,
  Flex,
  // Input,
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  // Text,
  useDisclosure,
  useSteps,
  useToast,
} from "@chakra-ui/react";
// import ErpConverter from "../ErpConverter/ErpConverter";
// import InputForm from "../InputForm/InputForm";
import {
  baseUrl,
  // editQtyToBeProduced,
  // getConstraintsAPI,
  // inConsistancy,
  optimizeBurdenMixAPI,
  // updateConstraintsAPI,
} from "../../Redux/App/app.actions";
// import Step0 from "./Step0";
import Step1 from "./Step1";
// import Step2 from "./Step2";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingModal from "../Modals/LoadingModal";
import ErrorModal from "../Modals/ErrorModal";
import errorIcon from "../Icons/error.png";
// import * as types from "../../Redux/App/app.actionTypes";
// import StepBin from "./StepBin";
import { StepZero } from "./StepZero/StepZero";
import StepOne from "./StepOne/StepOne";
import { getTentativeBurdenMixApi } from "../InputForm/Bounds/NestedSteps/services/nestedStepsServices";
import { getBinStatusDataApi } from "./StepOne/stepOneServices";
import { mixpanelTrackButton } from "../utils/mixpanelFunctions";

// export const handleTransformControllers = (
//   steps,
//   constraints,
//   controllers,
//   dataReady,
//   dispatch,
//   transformControllersAPI,
//   transformControllersAPI2,
//   types,
//   updateConstraintsAPI,
//   bounds_id,
//   bounds,
//   toast,
//   postDataForApi
// ) => {
//   // console.log({
//   //   steps,
//   //   constraints,
//   //   controllers,
//   //   dataReady,
//   //   dispatch,
//   //   transformControllersAPI,
//   //   transformControllersAPI2,
//   //   types,
//   //   updateConstraintsAPI,
//   //   bounds_id,
//   //   bounds,
//   //   toast,
//   //   postDataForApi,
//   // });
//   let stepsDict = steps?.reduce((acc, step) => {
//     const { name, value } = step;
//     acc[name] = value;
//     return acc;
//   }, {});

//   let LUMPS_plus_CHIPS_aim = constraints?.find(
//     (el) => el.name == "LUMPS_plus_CHIPS_aim"
//   )?.value;
//   let FBL_percent_aim = constraints?.find(
//     (el) => el.name == "FBL_percent_aim"
//   )?.value;

//   let LUMPS_BIN = controllers?.find((el) => el.name == "LUMPS_BIN")?.value;
//   let CHIPS_BIN = controllers?.find((el) => el.name == "CHIPS_BIN")?.value;
//   let FBL_BIN = controllers?.find((el) => el.name == "FBL_BIN")?.value;
//   let COMPOSITE_BQT_BIN = controllers?.find(
//     (el) => el.name == "COMPOSITE_BQT_BIN"
//   )?.value;
//   let NORMAL_BQT_BIN = controllers?.find(
//     (el) => el.name == "NORMAL_BQT_BIN"
//   )?.value;

//   stepsDict = {
//     ...stepsDict,
//     LUMPS_plus_CHIPS_aim,
//     FBL_percent_aim,
//     LUMPS_BIN,
//     CHIPS_BIN,
//     FBL_BIN,
//     COMPOSITE_BQT_BIN,
//     NORMAL_BQT_BIN,
//   };
//   // dispatch(transformControllersAPI(dataReady, stepsDict))
//   dispatch(inConsistancy());
//   dispatch(transformControllersAPI2(postDataForApi)).then((res) => {
//     if (res.type == types.TRANSFORM_CONTROLLERS_SUCCESS) {
//       dispatch(updateConstraintsAPI(bounds_id, bounds));
//     } else {
//       toast({
//         title: "Failed to updated controllers",
//         status: "error",
//         isClosable: true,
//         description: "",
//         duration: 5000,
//       });
//     }
//   });
// };

const HomeStepper = () => {
  const state = useSelector((state) => state);
  const raw_file = state?.app?.erp_file?.raw_file || null;
  const inputFile = state?.app?.inputFile || null;
  const [dataReadyArray, setDataReadyArray] = useState(null);
  const toast = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const response_loading = state.app.response_loading;
  const [progressPercent, setProgressPercent] = useState(0);
  const { isOpen, onOpen, onClose } = useDisclosure();
  // const total_qty = state?.app?.input_ore_material_sum;
  const [loadingTentativeBurdenMix, setLoadingTentativeBurdenMix] =
    useState(false);
  const [loadingBinStatus, setLoadingBinStatus] = useState(false);

  const steps = [
    { title: "ERP Converter" },
    { title: "Bin Status" },
    { title: "Review Constraints" },
    // { title: "Create Burden Mix" },
  ];

  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length,
  });

  // useEffect(() => {
  //   dispatch(getConstraintsAPI());
  // }, []);

  const handleChangeActiveStep = async (payload) => {
    try {
      let nextStep = activeStep + payload;
      if (nextStep == 2 || nextStep == 1) {
        if (!inputFile) {
          if (!raw_file) {
            return toast({
              title: "No ERP file found",
              description: "Please upload the ERP file to make data ready file",
              status: "error",
              duration: 4000,
              isClosable: true,
            });
          } else if (raw_file && !inputFile) {
            return toast({
              title: "No data ready file found",
              description: "please convert ERP to Data Ready before continuing",
              status: "error",
              duration: 4000,
              isClosable: true,
            });
          }
        }
      }

      if (nextStep == 3) {
        const tentativeBurdenMixResponse = await getTentativeBurdenMixApi(
          setLoadingTentativeBurdenMix
        );
        if (
          tentativeBurdenMixResponse?.success &&
          tentativeBurdenMixResponse?.data
        ) {
          await dispatch(optimizeBurdenMixAPI(state, dataReadyArray)).then(
            (res) => {
              let { type, payload } = res;
              if (type === "RESPONSE_SUCCESS") {
                navigate("/output");
              }
            }
          );
          return;
        } else {
          throw new Error(tentativeBurdenMixResponse?.message);
        }
      }
      if (nextStep == 2) {
        const binStatusResponse = await getBinStatusDataApi(
          setLoadingBinStatus
        );
        if (binStatusResponse?.status === "error") {
          const errors = binStatusResponse?.errors?.split(",");
          errors.forEach((error) => {
            throw new Error(error);
          });
        }
        // await dispatch(inConsistancy(state));
        // console.log("state----", state.app.binStatus.isSuccess);
        // const success = state.app.binStatus.isSuccess;
        // if (success) {
        //   toast({
        //     title: "Success",
        //     description: "",
        //     status: "success",
        //     duration: 2000,
        //     isClosable: true,
        //   });
        // } else {
        //   return toast({
        //     title: "Error",
        //     description: "Check Lot No Or Category",
        //     status: "error",
        //     duration: 2000,
        //     isClosable: true,
        //   });
        // }
      }
      setActiveStep((prev) => prev + payload);
    } catch (error) {
      console.error("An error occurred:", error);
      toast.closeAll();
      toast({
        title: error.message || "Unexpected Error",
        status: "error",
        isClosable: true,
        duration: null,
      });
    }
  };

  useEffect(() => {
    let intervalId;
    const config = {
      method: "get",
      url: `${baseUrl}/b1/progress`,
      headers: {
        "Client-Id": state.app.client_id,
      },
    };

    try {
      if (response_loading === true) {
        intervalId = setInterval(() => {
          axios.request(config).then((res) => {
            const totalGenerations = state.app.bounds.controllers.filter(
              (el) =>
                el.category === "TOP_CONTROLLERS" && el.name === "generations"
            )[0]?.value;
            const percent = Math.floor(
              (Number(res.data.generation) * 100) / Number(totalGenerations)
            );
            setProgressPercent(percent);
          });
        }, 3000);
      } else {
        setProgressPercent(0);
      }
    } catch (e) {
      console.log({ e });
    }

    return () => clearInterval(intervalId);
  }, [response_loading]);

  console.log("state", state);
  return (
    <Box w="95%" mx="auto">
      <LoadingModal
        isOpen={state.app.response_loading}
        onOpen={onOpen}
        onClose={onClose}
        title={"Loading"}
        text={"Please wait while we are optimizing the burden mix"}
        progressPercent={progressPercent}
      />
      <ErrorModal
        imageSrc={errorIcon}
        isOpen={state?.app?.response_failure}
        onOpen={onOpen}
        onClose={onClose}
        title={"Warning"}
        text={
          "Constraints can not be satisfied, please recheck available quantity of fixed lots in stock"
        }
      />
      <Stepper size="md" colorScheme="blue" index={activeStep} mt="1rem">
        {steps.map((step, index) => (
          <Step
            key={index}
            //   onClick={() => setActiveStep(index)}
          >
            <StepIndicator cursor="pointer">
              <StepStatus
                complete={<StepIcon />}
                incomplete={<StepNumber />}
                active={<StepNumber />}
              />
            </StepIndicator>

            <Box flexShrink="0">
              <StepTitle>{step.title}</StepTitle>
              <StepDescription>{step.description}</StepDescription>
            </Box>

            <StepSeparator />
          </Step>
        ))}
      </Stepper>
      <Box w="100%" h="50vh" mt="1rem">
        <Flex
          w="90%"
          bg="blue.200"
          bgColor="white"
          justifyContent="right"
          gap="1rem"
          mb="10px"
        >
          <Button
            isDisabled={activeStep === 0}
            onClick={() => {
              handleChangeActiveStep(-1);
              mixpanelTrackButton("home", "Prev") // mixpanel track button
            }}
            color="white"
            bg="#008001"
            borderRadius="5px"
            height="30px"
          >
            Prev
          </Button>
          <Button
            // isDisabled={activeStep === 2}
            onClick={() => {
              handleChangeActiveStep(1);
              mixpanelTrackButton("home", activeStep == 2 ? "Optimize" : "Next") // mixpanel track button
            }}
            bg="#008001"
            color="white"
            borderRadius="5px"
            height="30px"
          >
            {activeStep == 2 ? "Optimize" : "Next"}
          </Button>
        </Flex>
        <Flex justifyContent="center" alignItems="center">
          {(() => {
            switch (activeStep) {
              case 0:
                return (
                  <StepZero
                    dataReadyArray={dataReadyArray}
                    setDataReadyArray={setDataReadyArray}
                  />
                );
              case 1:
                return <StepOne dataReadyArray={dataReadyArray} />;
              // return <StepBin dataReadyArray={dataReadyArray} />;
              case 2:
                return <Step1 />;
              // case 3:
              //   return <Step2 />;
              default:
            }
          })()}
        </Flex>
      </Box>
    </Box>
  );
};

export default HomeStepper;
